<template>
  <q-list separator>
    <q-item-label header>Gecmis Randevular</q-item-label>

    <q-item v-for="appointment in appointments" :key="appointment.id">
      <q-item-section>
        <q-item-label
          ><span class="text-weight-light text-italic">
            {{
              timetravel.humanReadableAppointmentDateTime(
                appointment.appointmentStart,
                appointment.appointmentEnd
              )
            }}</span
          ></q-item-label
        >
      </q-item-section>

      <q-item-section>
        <q-item-label>
          <span class="text-weight">{{
            mappers.appointmentStatusMapper(appointment.appointmentStatus)
          }}</span>
        </q-item-label>
      </q-item-section>

      <q-item-section>
        <q-item-label>
          <span class="text-weight-medium">
            {{ mappers.appointmentTypeMapper(appointment.appointmentType) }}
          </span>
        </q-item-label>
      </q-item-section>

      <q-item-section
        v-if="
          appointment.appointmentType === 'INTRODUCTION' &&
          appointment.appointmentStatus === 'COMPLETED'
        "
        side
      >
        <div class="q-pa-md q-gutter-sm">
          <EditCustomerAppointment :appointment-id="appointment.id" />
        </div>
      </q-item-section>
    </q-item>
  </q-list>
</template>
<script>
import { ref, onMounted, inject } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import EditCustomerAppointment from './EditAppointment.vue'
import * as timetravel from '../../utils/timetravel'
import * as mappers from '../../utils/mapper'
import * as eventNames from '../../utils/events'
export default {
  components: {
    EditCustomerAppointment,
  },
  props: {
    customerId: String,
  },
  setup() {
    const appointments = ref({})
    const route = useRoute()
    const customerId = route.path.split('/').pop()
    const emitter = inject('emitter')
    emitter.on(eventNames.REFRESH_CUSTOMER_APPOINTMENTS, () => {
      getAppointments()
    })

    const getAppointments = () => {
      axios.get(`/customers/${customerId}/appointment`).then((response) => {
        appointments.value = response.data
      })
    }

    onMounted(() => {
      getAppointments()
    })

    return {
      appointments,
      timetravel,
      mappers,
      EditCustomerAppointment,
      getAppointments,
    }
  },
}
</script>
